@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.profile.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.profile.resources/"

@delegate:ResourceContentHash(-23_014_280)
internal val Res.array.profile_months: StringArrayResource by lazy {
      StringArrayResource("string-array:profile_months", "profile_months", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 211),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 87),
      ))
    }

@delegate:ResourceContentHash(-960_026_690)
internal val Res.array.saved_months: StringArrayResource by lazy {
      StringArrayResource("string-array:saved_months", "saved_months", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 222, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 142, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98, 85),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("profile_months", Res.array.profile_months)
  map.put("saved_months", Res.array.saved_months)
}
